var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationSubmit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 148,
    viewBox: "0 0 122 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.13 14.8L93.6404 6.08004C89.7904 3.86004 85.0504 3.86004 81.1904 6.08004L10.9004 46.53C7.03039 48.76 4.65039 52.88 4.65039 57.34V121.51C4.65039 125.97 7.03039 130.08 10.8904 132.31L27.3804 141.21C31.2404 143.44 36.0004 143.44 39.8604 141.21L110.16 100.57C114.02 98.34 116.4 94.22 116.4 89.77V25.61C116.4 21.15 114.02 17.02 110.15 14.8",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7202 50.4696C59.6702 59.6796 46.6802 80.6896 46.7002 97.3996C46.7202 114.11 59.7502 120.19 75.8002 110.98C91.8502 101.77 104.84 80.7596 104.82 64.0496C104.8 47.3396 91.7702 41.2596 75.7202 50.4696",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5801 92.03L70.4401 100.51L89.5301 64.75",
    stroke: "#0129FA",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationSubmit);
export default __webpack_public_path__ + "static/media/applicationSubmit.1eda0ffa5c4ec1f9d7d8db1464846f66.svg";
export { ForwardRef as ReactComponent };